import React, { FC } from "react";
import { Button, Table, Tooltip, message, Upload } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { IMaterialDetailModel, useMaintenanceDetailsModel } from "./maintenanceDetailsModels";
import { IMaterialDetailList } from "../../maintenanceType";
import { formatIntPoint, repairFormatNum, formatIntPoint1, formatNum } from "@/utils/utils";
import { components } from "@/components/YHEditTable/editTable";
import { DetailType, IServiceNatureCodeType, IPriceTypeEnum } from "@/types/ScmEnums";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { ITopType } from "@/types/ScmTypes";
import { YhBut } from "@/components/YhButton";
import { globalPrompt } from "@/components/message";
import { debounce } from "lodash";
import { IVRMSettleTypeEnum } from "@/types/FmsDs";
import useGlobalModel from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { importPropsConfig } from "@/utils/importFile";
import { purchaseDetailsService } from "@/views/stock/purchaseDetails/purchaseDetailsService";
import { useSaleSoDetailModel } from "@/views/sale/so/view/details/saleSoDetailModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import YhTootip from "@/components/YhTootip";

export const MaterialTableBox: FC<ITopType> = ({ id, mode, IFormRef }) => {
    const { shopAndOrg: { shopId }, getSettlementParty } = useGlobalModel();
    const {
        detailAddForm,
        detailEditForm,
        setMaterialModel,
        detailMaterialAddList, setDetailMaterialAddList,
        detailMaterialAddDataRowKeys, setDetailMaterialAddDataRowKeys,
        setDetailMaterialAddDataRow,
        detailMaterialEditList, setDetailMaterialEditList,
        detailMaterialEditDataRowKeys, setDetailMaterialEditDataRowKeys,
        setDetailMaterialEditDataRow,
        detailMaterialLookList,
        detailMaterialDetailList,
        setTopButsControl,
        setHistoryVisible,
        setHistoryRow,
        transformsToPoMaterialDetailList
    } = useMaintenanceDetailsModel();
    let { priceTypeCode, serviceNatureCode, customerCode, status } = mode === "add" ? detailAddForm : detailEditForm;
    const { downloadTpl } = useSaleSoDetailModel()

    const { getTreeNodeOne } = useDictModel();
    const onHistoryModel = (record: IMaterialDetailList) => {
        setHistoryVisible(true)
        setHistoryRow(record)
    }
    const switchModelViaible = () => {
        IFormRef.current?.validateFields().then(async res => {
            if (mode === "add") {
                let { customerCode, customerName, payType, settlementPartyCode, bentityCode } = detailAddForm as { customerCode: string, payType: IVRMSettleTypeEnum, customerName: string, settlementPartyCode: string, bentityCode: string }
                if (!(customerCode && customerName && payType && settlementPartyCode)) {
                    message.warning("请补全客户名称或结算类型或结算方")
                    return false
                }
                let { accountName, availableAmount, isBill, accountCustomerName } = await getSettlementParty({ settlementPartyCode, customerName, customerCode, payType, settlementsettlementPartyParams: getTreeNodeOne(settlementPartyCode as string)[0], bentityCode });

                if (payType !== IVRMSettleTypeEnum.SETTLE_CASH) {
                    if (accountName && availableAmount > 0) {
                        materialTips(`当前${accountName},授信额度为${availableAmount},是否确认？？`, true)
                    } else if (accountName && availableAmount === 0) {
                        materialTips(`当前${accountName},授信额度为${availableAmount}，不可开单，是否确认？？`, false)
                    } else if (!accountName) {
                        materialTips(`当前${accountCustomerName}，无对应账户，无法开单，是否确认？？`, false)
                    }
                } else {
                    setMaterialModel(true)
                }
            } else {
                setMaterialModel(true)
            }
        })
    }
    const materialTips = (info: string, visible: boolean) => {
        globalPrompt("modal", {
            title: "新增维修项目",
            type: "warning",
            text: info,
            okText: "确定",
            onOk: debounce(async () => { visible && await setMaterialModel(visible) }, 500),
            cancelText: "取消",
            onCancel: () => { }
        })
    }
    const importCallback = async (list: IMaterialDetailModel[]) => {
        if (!list) return;
        let newImportList = await Promise.all(list?.map(async (item: any) => {
            let { stockId, latestPurPrice, materialCode, lateSalePrice, discountRate, petroleumPrice, purchasePrice, retailPrice, num, ...params } = item as { latestPurPrice: number, lateSalePrice: number, purchasePrice: number, petroleumPrice: number, retailPrice: number, num: number, materialCode: string, discountRate: number, stockId: string }
            let newPrice: number = latestPurPrice ?? purchasePrice;
            if (!(serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM_J || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_MAINTAIN)) {
                switch (priceTypeCode) {
                    //售价选择 客户最近销价 (需要通过接口查询，客户最近一次的销售价)
                    case IPriceTypeEnum.CUSTOMER_LATEST:
                        let { retData: { price } } = await purchaseDetailsService.recentSalesPrice(shopId, materialCode, customerCode as string);
                        newPrice = +price;
                        break;
                    //售价选择 最近销价 
                    case IPriceTypeEnum.RECENT:
                        newPrice = lateSalePrice ?? retailPrice;
                        break;
                    //售价选择 零售价
                    case IPriceTypeEnum.RETAIL:
                        newPrice = retailPrice;
                        break;
                    //售价选择 采购成本价
                    case IPriceTypeEnum.PUR_COST:
                        newPrice = latestPurPrice ?? purchasePrice;
                        break;
                    //售价选择 档案进价
                    case IPriceTypeEnum.BUYING_PRICE:
                        newPrice = purchasePrice ?? latestPurPrice;
                        break;
                    //售价选择 石油价格
                    case IPriceTypeEnum.PETROLEUM:
                        newPrice = petroleumPrice ?? purchasePrice
                        break;
                }
            }
            return {
                ...item,
                id: stockId,
                num,
                price: newPrice,
            }
        }) ?? [])
        transformsToPoMaterialDetailList(mode, newImportList)
    }
    const isMaterialModel = () => {
        if (mode === "look") return false
        if (mode === "edit" && (detailEditForm.status === DictCodeEnmu.MAINTENANCE_COMPLETED || detailEditForm.status === DictCodeEnmu.MAINTENANCE_SETTLE || detailEditForm.status === "maintenance-status.paying")) {
            return false;
        }
        return true;
    }
    const action = <>
        {isMaterialModel() && <>
            <YhAuth resCode={ResourceAuthEnum.M_ED_ADD_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={mode === "edit" && (detailEditForm.status === "maintenance.completed" || detailEditForm.status === "maintenance-status.final")}
                    onClick={() => switchModelViaible()}
                >新增商品</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.M_ED_DEL_M}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={mode === "edit" && (detailEditForm.status === "maintenance.completed" || detailEditForm.status === "maintenance-status.final")}
                    onClick={() => detailMaterialDetailList(mode)}
                >删除商品</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.S_S_ED_IM}>
                <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/zzw-vrm/sale/details/import/${shopId}`, importCallback)}>
                    <Button
                        disabled={!(serviceNatureCode && customerCode)}
                        className="mr-5"
                        type="primary"
                        shape="round">导入</Button>
                </Upload>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.S_S_ED_DLOAD}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={downloadTpl}
                >下载模板</Button>
            </YhAuth>
        </>}
    </>;
    const removeMaterial = (record: IMaterialDetailList) => {
        detailMaterialDetailList(mode, record)
    }
    const MaterialColumns = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '配件编码',
            width: 100,
            dataIndex: 'materialCode',
            // render: (text: any, record: any, index: number) => <Tooltip placement="topLeft" title={text}><p className="ellipsis click-span" onClick={() => onHistoryModel(record)}>{text}</p></Tooltip>,
            render: (text: any, record: any, index: number) => <YhTootip text={text} onClick={() => onHistoryModel(record)} />,
            sorter: {
                compare: (a: { materialCode: string; }, b: { materialCode: string; }) => {
                    if (a.materialCode.charCodeAt(0) == b.materialCode.charCodeAt(0)) {
                        return a.materialCode.charCodeAt(0) - b.materialCode.charCodeAt(0)
                    }
                    return a.materialCode.charCodeAt(0) - b.materialCode.charCodeAt(0)
                },
                multiple: 1,
            },
        }, {
            title: '配件名称',
            width: 120,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '可用库存',
            width: 100,
            dataIndex: 'inventoryNum',
        }, {
            title: '库房',
            width: 140,
            dataIndex: 'warehouseName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '数量',
            width: 100,
            dataIndex: 'num',
            editable: isMaterialModel()
        }, {
            title: '单价',
            width: 100,
            dataIndex: 'price',
            editable: isMaterialModel(),
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '配件费',
            width: 100,
            dataIndex: 'materialAmount',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '折扣',
            width: 80,
            dataIndex: 'discountRate',
            editable: isMaterialModel(),
            render: (text: string) => text + "%"
        },
        {
            title: '折后金额',
            width: 100,
            dataIndex: 'discountedAmount',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '单项优惠金额',
            width: 140,
            dataIndex: 'decreaseAmount',
            editable: isMaterialModel(),
            render: (text: any) => `￥${formatNum(text)}`
        },
        {
            title: '小计',
            width: 100,
            dataIndex: 'receivableAmount',
            render: (text: any) => text < 0 ? `-￥${formatNum(text)}` : `￥${formatNum(text)}`
        }, {
            title: '货位',
            width: 140,
            dataIndex: 'shelfCode',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '采购单号',
            width: 180,
            dataIndex: 'purchaseCode',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
            editable: isMaterialModel()
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            align: "center",
            render: (text: any, record: any) =>
                isMaterialModel() && <YhBut
                    type="delete"
                    txt="删除"
                    click={() => removeMaterial(record)}
                />
        }
    ];

    const newSelectMaterialColums = () =>
        MaterialColumns.map((col: any, index) => {
            //已结算 已完工  审核中 审核通过  在修状态下 明细是出库状态的 不可以进行数量编辑
            let numEditable = !!(status !== DictCodeEnmu.MAINTENANCE_STOCK_IO && status !== DictCodeEnmu.MAINTENANCE_COMPLETED && status !== DictCodeEnmu.MAINTENANCE_SETTLE && status !== DictCodeEnmu.MAINTENANCE_APPROVED && status !== DictCodeEnmu.MAINTENANCE_UNDER_REVIEW)
            return {
                ...col,
                onCell: (record: IMaterialDetailList, rowIndex: number) => ({
                    colIndex: index + 1,
                    rowIndex,
                    record,
                    rules: col.rules,
                    options: col.options,
                    editType: col?.editType,
                    suffix: col.suffix,
                    editable: col.dataIndex === 'num' ? (numEditable && record.status !== "details.preparation.ware.out") : col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: handleMaterialSave,
                }),
            }
        })
    const handleMaterialSave = (row: IMaterialDetailList) => {
        // debugger;
        let { num, price, discountRate, inventoryNum, purchasePrice, latestPurPrice, termNum, decreaseAmount, discountedAmount, receivableAmount } = row;
        const newServiceNatureCode = mode === "add" ? detailAddForm.serviceNatureCode : detailEditForm.serviceNatureCode;
        price = newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM || serviceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CLAIM_J || newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_MAINTAIN ?
            +formatIntPoint1(price, latestPurPrice, `修改价格不应小于进货价${latestPurPrice}`) : newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ?
                +repairFormatNum(price) : +formatIntPoint1(price, latestPurPrice, `修改价格不应小于进货价${latestPurPrice}`)
        num = mode === "add" ? +formatIntPoint(num, inventoryNum, "选择数量>=可用库存数量") : +formatIntPoint(num, termNum ? termNum : inventoryNum, "选择数量>=可用库存数量");  //数量
        discountRate = +formatNum(discountRate);
        discountRate = +formatIntPoint(discountRate, 100, '折扣不能高于100%');  //折扣
        let newPrice = newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? price : +formatNum(price)
        // 折后金额
        discountedAmount = newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum((num * newPrice * discountRate) / 100) : +formatNum((num * newPrice * discountRate) / 100)
        // decreaseAmount = +formatIntPoint(decreaseAmount, 1, '单项优惠金额不能大于1元')
        // 小计
        receivableAmount = +formatNum(discountedAmount - decreaseAmount)
        let newRow = {
            ...row,
            num: newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(num) : +formatNum(num),
            price: newPrice,
            discountRate,
            materialAmount: newServiceNatureCode === IServiceNatureCodeType.REPAIR_TYPE_CHAE ? +repairFormatNum(num * newPrice) : +formatNum(num * newPrice),
            decreaseAmount,
            discountedAmount,
            receivableAmount
        }

        let newData = mode === "edit" ? detailMaterialEditList : detailMaterialAddList;
        const index = newData.findIndex((item) => row.detailsId === item.detailsId);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...newRow });
        mode === "edit" ? setDetailMaterialEditList([...newData]) : setDetailMaterialAddList([...newData])
        setTopButsControl(true)
    }
    const typeMaterialList = {
        "add": [...detailMaterialAddList],
        "edit": [...detailMaterialEditList],
        "look": [...detailMaterialLookList],
    }
    //设置维修用料选中的行和数据
    const setTypeMaterialDetailDataRowKeysAndRow = async (selectedRowKeys: React.Key[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailMaterialAddDataRowKeys(selectedRowKeys)
        } else if (mode === DetailType.edit) {
            setDetailMaterialEditDataRowKeys(selectedRowKeys)
        }
    }
    const setTypeMaterialDetailDataRow = async (selectedRows: IMaterialDetailList[], mode: string) => {
        if (mode === DetailType.add) {
            setDetailMaterialAddDataRow(selectedRows)
        } else if (mode === DetailType.edit) {
            setDetailMaterialEditDataRow(selectedRows)
        }
    }

    return (
        <YhBox title="维修用料" rightChildren={action} style={{ marginBottom: "75px" }}>
            <Table
                bordered
                rowKey={record => record.detailsId as string}
                rowClassName='editable-row yh-edit-table-tr'
                columns={newSelectMaterialColums() as ColumnsType<IMaterialDetailList>}
                dataSource={typeMaterialList[mode] as IMaterialDetailList[]}
                rowSelection={
                    mode === "look" ? undefined : {
                        selectedRowKeys: mode === DetailType.add ? detailMaterialAddDataRowKeys : detailMaterialEditDataRowKeys, //记录选中
                        onChange: (selectedRowKeys: React.Key[], selectedRows: IMaterialDetailList[]) => {
                            setTypeMaterialDetailDataRowKeysAndRow(selectedRowKeys, mode)
                            setTypeMaterialDetailDataRow(selectedRows, mode)
                        },
                        onSelectAll: (selected, selectedRows, changeRows) => {
                            setTypeMaterialDetailDataRow(selectedRows, mode)
                        }
                    }}
                components={components}
                pagination={false}
                scroll={{ x: 'max-content', y: 350 }}
            />
        </YhBox>
    )
}